import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SpecialtyDropdown from "../shared/SpecialtyDropdown";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import GreenCheck from "../../assets/images/svg-icons-material-io/check_FILL0_wght400_GRAD0_opsz48.svg";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import $ from "jquery";

const EditOrg = ({ editObj, vendorId, closeEdit }) => {
  const navigate = useNavigate();
  const {
    isUserLogedIn,
    userRole,
    userToken,
    sharedObject,
    SetSharedObject,
    XdrArr,
    setXDRArr,
  } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
    sharedObject: state.sharedObject,
    SetSharedObject: state.SetSharedObject,
    XdrArr: state.XdrArr,
    setXDRArr: state.setXDRArr,
  }));
  const [answers, setAnswers] = useState(null);
  const [orgValues, SetOrgValues] = useState([]);
  const [processing, SetProcessing] = useState(false);
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [msg, SetMsg] = useState("");
  const [colorMsg, SetColorMsg] = useState("danger");
  const [EnabledXDR, SetEnabledXDR] = useState(false);
  const [CustomerCheckboxes, SetCustomerCheckboxes] = useState([]);
  const [xdr, setXDR] = useState(false);
  const [customerPermissionsObj, SetCustomerPermissionsObj] = useState({});
  const [permissions, SetPermissions] = useState(true);
  const [specialtiesObj, setSpecialtiesObj] = useState({});
  const [specialtiesFlag, SetspecialtiesFlag] = useState(false);
  const [phoneValidation, SetPhoneValidation] = useState(false);
  const [faxValidation, SetFaxValidation] = useState(false);
  const setAnswer = async (questionId, answer, chck) => {
    if (chck) {
      let obj = { ...answers };
      let add = answers.Addresses;
      add[questionId] = answer;
      obj.Addresses = add;
      await setAnswers(obj);
    } else {
      await setAnswers({ ...answers, [questionId]: answer });
    }
  };

  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }
  const buildForm = (frm) => {
    const listAddress = (frm) => {
      let o = {};
      if (frm?.addresses && frm?.addresses.length > 0) {
        let obj = frm?.addresses[0];
        o = {
          FirstLine: obj.firstLine,
          SecondLine: obj.secondLine,
          City: obj.city,
          State: obj.state,
          County: obj.secondLine,
          PostalCode: obj.postalCode,
          Country: obj.country,
          Phone: obj.phone.substring(0, 10),
          PhoneExt: obj.phone.substring(10, obj.phone.length),
          Fax: obj?.fax?.substring(0, 10),
          FaxExt: obj?.fax?.substring(10, obj.fax.length),
          AddressType: obj.addressType,
          IsCertAddress: obj.isCertAddress,
        };
      }
      return o;
    };
    const listSpecial = (frm) => {
      let o = [];
      if (frm?.specialties && frm?.specialties.length > 0) {
        let obj = frm?.specialties[0];
        o = [
          {
            Classification: obj.classification,
            Code: obj.code,
            Definition: obj.definition,
            Id: obj.id,
            Notes: obj.notes,
            Specialization: obj.specialization,
            Type: obj.type,
          },
        ];
      }
      return o;
    };
    const ListIds = (ob) => {
      let temp = [];
      if (ob && ob.length > 0) {
        for (let id of ob) {
          let obj = {
            RecordId: id.recordId,
            IDTypeString: id.idTypeString,
            IDType: id.idType,
            Value: id.value,
            IssuingAuthority: id.issuingAuthority,
          };
          temp.push(obj);
        }
      }

      return temp;
    };
    let ob = {
      AdminCount: frm?.adminCount,
      CredentialText: frm?.credentialText,
      DomainBox: "",
      DomainId: frm?.domainId,
      DomainName: frm?.domainName,
      ExternalId: frm?.externalId ? frm?.externalId : "",
      IDs: ListIds(frm?.iDs),
      Id: frm?.id,
      IsCsrOrg: frm?.isCsrOrg,
      IsEpicOrganization: frm?.isEpicOrganization,
      KeepMDN: frm?.keepMDN,
      NPI: frm?.npi,
      OrgEmailCount: frm?.orgEmailCount,
      OrganizationKind: frm?.organizationKind,
      OrganizationName: frm?.organizationName,
      OrganizationType: frm?.organizationType,
      /*OutOfNetwork: frm?.outOfNetwork,*/
      ParentOrg: "",
      ParentOrganizationId: frm?.parentOrganizationId,
      ParentOrganizationName: frm?.parentOrganizationName,
      Specialties: listSpecial(frm),
      Addresses: listAddress(frm),
      SubOrgCount: frm?.subOrgCount,
      UserCount: frm?.userCount,
      UserEmailCount: frm?.userEmailCount,
      VendorId: frm?.vendorId,
      XDRDoNOTGenerateXDM: frm?.xdrDoNOTGenerateXDM,
      XDREnabled: frm?.xdrEnabled,
      xdrConfig: frm?.xdrConfig,
      OutboundXDRConfigName: frm?.xdrConfig?.id ? frm?.xdrConfig?.id : "",
      AllowTwoFactor: false,
      ApplicationAccessXDR: frm?.applicationAccessXDR,
      specializationCode: frm?.specializationCode,
      TwoFactorAuth: frm?.twoFactorAuth,
      ApplicationAccessENS: frm?.applicationAccessENS,
      EmailForwardingType: frm?.emailForwardingType,
      EmailForwardingTypeBox: frm?.emailForwardingType === 2 ? true : false,
      DirectRoute: frm?.emailForwardingType === 1 ? true : false,
      ShareDirectoryListing: frm?.shareDirectoryListing,
    };
    if (ob.Addresses?.Phone != null) {
      ob.Addresses.Phone = formatPhoneNumber(frm.addresses[0].phone);
    }
    if (ob.Addresses?.Fax != null) {
      ob.Addresses.Fax = formatPhoneNumber(frm.addresses[0].fax);
    }
    SetEnabledXDR(frm?.xdrEnabled);
    if (frm?.xdrConfig?.id) {
      GetXdrConfig(frm?.xdrConfig.id);
    }
    setAnswers(ob);
    setSpecialtiesObj(ob.Specialties);
  };

  const [CustCheckboxes, SetCustCheckboxes] = useState({});
  const customerCheckboxes = (customerId) => {
    var customer = sharedObject.vendorsObj.find((element) => {
      return element.id === parseInt(customerId);
    });
    var ob = {
      EmailForwardingType: customer?.emailForwardingType,
      ApplicationAccessXDR: customer?.applicationAccessXDR,
      ApplicationAccessENS: customer?.applicationAccessENS,
      TwoFactorAuth: customer?.twoFactorAuth,
      EmailForwardingType: customer?.emailForwardingType,
      ShareDirectoryListing: customer?.directorySharing,
    };
    SetCustCheckboxes(ob);
  };

  const ClearFields = async () => {
    buildForm(sharedObject.orgActionObj);
  };
  useEffect(() => {
    SetErrCreateMsg(false);
    const getOrgVals = async (val) => {
      SetSharedObject("xdrSettiingObj", {});
      SetProcessing(true);
      let call = "/organization/GetOrgValues?Type=" + val;
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        SetOrgValues(res.data.data);
      } else if (res.status === "SERVERERROR") {
        SetProcessing(false);
      }
      SetProcessing(false);
    };
    if (editObj) {
      getOrgVals("sub");
    }
    buildForm(sharedObject.orgActionObj);
    SetCustomerPermissionsObj(sharedObject.CustomerPermissionsObj);
    getXDREndPoints();
    customerCheckboxes(sharedObject?.orgActionObj?.vendorId);
    SetspecialtiesFlag(false);
    if (sharedObject?.xdrAdded) {
      GetXdrConfig(sharedObject.xdrAdded);
    }
    return () => {
      SetspecialtiesFlag(false);
      ClearFields();
      SetErrCreateMsg(false);
      SetSharedObject("xdrAdded", false);
    };
  }, [sharedObject.orgActionObj]);

  useEffect(() => {
    if (
      CustCheckboxes.EmailForwardingType === 0 &&
      CustCheckboxes.TwoFactorAuth === false &&
      CustCheckboxes.ApplicationAccessXDR === false &&
      CustCheckboxes.ApplicationAccessENS === false &&
      CustCheckboxes.ShareDirectoryListing === false
    ) {
      SetPermissions(true);
    } else {
      SetPermissions(false);
    }
  }, [CustCheckboxes]);
  const getXDREndPoints = async () => {
    SetProcessing(true);
    let call = "/organization/getAllXDREndPoints";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      await setXDRArr(res.data.data);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    SetProcessing(false);
  };
  const CheckSpecialty = () => {
    let flag =
      isEmpty(sharedObject.specialties.Code) &&
      (!isEmpty(sharedObject.specialties.Type) ||
        !isEmpty(sharedObject.specialties.Classification));
    return flag;
  };
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  const ValidatePhoneFax = (str) => {
    let nr = str.replace(/[^0-9]/g, "").substring(0, 10);
    return nr.length === 10;
  };
  const updateOrg = async () => {
    SetFrmSubmFlag(true);
    SetspecialtiesFlag(false);
    SetErrCreateMsg(false);
    // if (!answers.OrganizationKind) {
    //   document.getElementById("OrganizationKind").scrollIntoView();
    //   document.getElementById("OrganizationKind").focus();
    //   return;
    // } else
    if (!answers.Addresses?.FirstLine) {
      document.getElementById("FirstLine").scrollIntoView();
      document.getElementById("FirstLine").focus();
      return;
    } else if (!answers.Addresses?.City) {
      document.getElementById("City").scrollIntoView();
      document.getElementById("City").focus();
      return;
    } else if (!answers.Addresses?.State) {
      document.getElementById("State").scrollIntoView();
      document.getElementById("State").focus();
      return;
    } else if (!answers.Addresses?.PostalCode) {
      document.getElementById("PostalCode").scrollIntoView();
      document.getElementById("PostalCode").focus();
      return;
    } else if (!answers.Addresses?.Phone) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    } else if (CheckSpecialty()) {
      SetspecialtiesFlag(true);
      return;
    }
    if (answers.XDREnabled) {
      let flg = isEmpty(answers.xdrConfig.id);
      if (flg) {
        SetMsg("Please select an XDR Endpoint");
        SetErrCreateMsg(true);
        return;
      }
    }
    if (
      answers?.Addresses?.PostalCode?.length < 5 ||
      answers?.Addresses?.PostalCode?.length > 5
    ) {
      document.getElementById("PostalCode").scrollIntoView();
      document.getElementById("PostalCode").focus();
      return;
    }
    if (!ValidatePhoneFax(answers.Addresses.Phone)) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      SetPhoneValidation(true);
      return;
    }
    if (
      !isEmpty(answers.Addresses.Fax) &&
      !ValidatePhoneFax(answers.Addresses.Fax)
    ) {
      document.getElementById("Fax").scrollIntoView();
      document.getElementById("Fax").focus();
      SetFaxValidation(true);
      return;
    }
    SetFrmSubmFlag(false);
    let PhoneExtNr = !isEmpty(answers.Addresses.PhoneExt)
      ? answers.Addresses.PhoneExt
      : "";
    answers.Addresses.Phone =
      answers.Addresses.Phone.replace(/[^0-9]/g, "").substring(0, 10) +
      PhoneExtNr;

    let FaxNr = answers.Addresses.Fax
      ? answers.Addresses.Fax.replace(/[^0-9]/g, "").substring(0, 10)
      : "";
    let FaxExtNr = !isEmpty(answers.Addresses.FaxExt)
      ? answers.Addresses.FaxExt
      : "";
    if (!isEmpty(FaxNr)) {
      answers.Addresses.Fax = `${FaxNr}${FaxExtNr}`;
    } else {
      answers.Addresses.Fax = "";
    }

    answers.Addresses = [answers.Addresses];

    let specCode = null;
    if (answers.specializationCode) {
      specCode = answers.specializationCode;
    } else {
      answers.Specialties = [];
    }
    if (answers?.xdrConfig?.id) {
      let xdr = answers.xdrConfig;
      let xConfig = {
        ClientCertificate: xdr.clientCertificate,
        ClientCertificateFindValue: xdr.clientCertificateFindValue,
        EndpointAddress: xdr.endpointAddress,
        EndpointName: xdr.endpointName,
        Id: xdr.id,
        IsValid: xdr.isValid,
        MDNForward: xdr.mdnForward,
        SendXDMBody: xdr.sendXDMBody,
        OrganizationId: xdr.organizationId,
        SchemaValidateRequest: xdr.schemaValidateRequest,
        SchemaValidateResponse: xdr.schemaValidateResponse,
        SchemaValidatorOn: xdr.schemaValidatorOn,
        UseConfigFile: xdr.useConfigFile,
      };

      answers.xdrConfig = xConfig;
    }
    SetProcessing(true);
    var finalAnswers = answers;
    finalAnswers.EmailForwardingType = EmailForwardingType;
    let sCode = specCode ? specCode : "Empty";
    let call =
      "/organization/CreateUpdateOrganization?specializationCode=" + sCode;
    const res = await CallAPI(call, finalAnswers, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      closeEdit(answers);
      $("#editOrgModal").modal("hide");
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      if (Object.keys(msg).length > 0 && msg.constructor === Object) {
        let str = "<div>";
        for (let el in msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetMsg(str);
      } else {
        SetMsg(msg);
      }
      SetErrCreateMsg(true);
      SetColorMsg("danger");
      SetProcessing(false);
      answers.Addresses = answers.Addresses[0];
      $(".modal").modal("hide");
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    SetProcessing(false);
  };
  const SpecialFormFields = async (val) => {
    await setAnswers({
      ...answers,
      Specialties: [val],
      specializationCode: val.Code,
    });
  };
  const GetXdrConfig = (vl) => {
    let temp = {};
    for (let el of XdrArr) {
      if (el.id === parseInt(vl)) {
        temp = el;
        break;
      }
    }
    SetSharedObject("xdrSettiingObj", temp);
    setAnswers({ ...answers, xdrConfig: temp, OutboundXDRConfigName: vl });
  };
  const handleXDR = () => {
    GetXdrConfig(answers.xdrConfig.id);
    $("#xdrSettingModal").modal("show");
  };
  const [EmailForwardingType, SetEmailForwardingType] = useState(0);
  const setDirectRoute = (val) => {
    if (val === true) {
      SetEmailForwardingType(1);
    } else {
      SetEmailForwardingType(0);
    }
    setAnswer("DirectRoute", val);
  };

  const setAdvancedDirectRoute = (val) => {
    if (val === true) {
      SetEmailForwardingType(2);
    } else {
      SetEmailForwardingType(0);
    }
    setAnswer("EmailForwardingTypeBox", val);
  };
  return (
    <div className="EditOrg">
      <div
        className="modal fade"
        data-backdrop="false"
        id="editOrgModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="DetailsOrganization"
        aria-hidden="false"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div
                className="modal-title spacer-inline text-size3"
                id="myModalLabel"
              >
                {" "}
                Edit Details{" "}
              </div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={(e) => {
                  $("#editOrgModal").modal("hide");
                  SetErrCreateMsg(false);
                  ClearFields();
                }}
              >
                {" "}
                <span aria-hidden="false">&times;</span>{" "}
              </button>
            </div>
            <form className="needs-validation" noValidate>
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header">
                    <i className="bi bi-building-fill text-size5 blk-clr"></i>
                    <div className="text-size6 ft-wt blk-clr spacer-margin7">
                      {answers?.OrganizationName}
                    </div>
                  </div>
                  <hr />
                  {/*Org Type*/}
                  {/*<div className="field-wrapper">*/}
                  {/*  <label for="OrgType">Organization Type</label>*/}
                  {/*  <select*/}
                  {/*    className="form-control"*/}
                  {/*    name="OrganizationKind"*/}
                  {/*    id="OrganizationKind"*/}
                  {/*    value={answers?.OrganizationKind}*/}
                  {/*    onChange={(el) =>*/}
                  {/*      setAnswer("OrganizationKind", parseInt(el.target.value))*/}
                  {/*    }*/}
                  {/*  >*/}
                  {/*    <option value="">Select</option>*/}
                  {/*    {orgValues?.getOrgKinds?.value.data.map((el) => (*/}
                  {/*      <option key={el.id} value={el.id}>*/}
                  {/*        {el.name}*/}
                  {/*      </option>*/}
                  {/*    ))}*/}
                  {/*  </select>*/}
                  {/*  {answers?.OrganizationKind === "" && frmSubmFlag ? (*/}
                  {/*    <div className="alert alert-danger"> Required! </div>*/}
                  {/*  ) : null}*/}
                  {/*</div>*/}
                  {/*Contact Information*/}
                  {/*<div className="field-wrapper title-divider">*/}
                  {/*  Contact Information*/}
                  {/*</div>*/}
                  <div className="field-wrapper">
                    <label for="FirstLine">Address 1</label>
                    <input
                      className="form-control"
                      name="FirstLine"
                      id="FirstLine"
                      value={answers?.Addresses?.FirstLine}
                      onChange={(el) =>
                        setAnswer("FirstLine", el.target.value, true)
                      }
                    />
                    {!answers?.Addresses?.FirstLine && frmSubmFlag ? (
                      <div className="alert alert-danger">
                        Address is required.
                      </div>
                    ) : null}
                  </div>
                  {/*Address 2*/}
                  <div className="field-wrapper">
                    <label for="SecondLine">Address 2</label>
                    <input
                      className="form-control"
                      name="SecondLine"
                      placeholder="Optional"
                      value={answers?.Addresses?.SecondLine}
                      onChange={(el) =>
                        setAnswer("SecondLine", el.target.value, true)
                      }
                    />
                  </div>
                  <div className="field-wrapper">
                    <label for="city">City</label>
                    <input
                      className="form-control"
                      name="City"
                      id="City"
                      value={answers?.Addresses?.City}
                      onChange={(el) =>
                        setAnswer("City", el.target.value, true)
                      }
                      disabled
                    />
                    {!answers?.Addresses?.City && frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div className="alert alert-danger">
                          City is required.
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="field-wrapper">
                    {/*State*/}
                    <div className="org-contact-wrapper field-ext">
                      <label for="State">State</label>
                      <select
                        className="form-control"
                        name="State"
                        id="State"
                        value={answers?.Addresses?.State}
                        onChange={(el) =>
                          setAnswer("State", el.target.value, true)
                        }
                        disabled
                      >
                        <option value="">Select</option>
                        {stateCodeArray.map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/*Zip Code*/}
                    <div className="org-contact-wrapper field-ext">
                      <label for="PostalCode">Zip</label>
                      <input
                        className="form-control"
                        id="PostalCode"
                        name="PostalCode"
                        value={answers?.Addresses?.PostalCode}
                        onChange={(el) =>
                          setAnswer("PostalCode", el.target.value, true)
                        }
                      />
                    </div>
                    {!answers?.Addresses?.State && frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div className="alert alert-danger">
                          State is required.
                        </div>
                      </div>
                    ) : null}
                    {!answers?.Addresses?.PostalCode && frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div className="alert alert-danger">
                          Zip Code is required.
                        </div>
                      </div>
                    ) : null}
                    {answers?.Addresses?.PostalCode?.length < 5 &&
                    frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div className="alert alert-danger">
                          Invalid Zip Code.
                        </div>
                      </div>
                    ) : null}
                  </div>
                  {/*Phone*/}
                  <div className="field-wrapper ">
                    <div className="field-box1">
                      <label for="Phone">Phone</label>
                      <input
                        className="form-control"
                        id="Phone"
                        name="Phone"
                        value={formatPhoneNumber(answers?.Addresses?.Phone)}
                        onChange={(el) =>
                          setAnswer("Phone", el.target.value, true)
                        }
                      />
                      {!answers?.Addresses?.Phone && frmSubmFlag ? (
                        <div className="alert alert-danger">
                          Phone number is required.
                        </div>
                      ) : null}
                      {answers?.Addresses?.Phone &&
                      answers?.Addresses?.Phone?.length < 14 &&
                      frmSubmFlag ? (
                        <div className="alert alert-danger">
                          Invalid Phone Number
                        </div>
                      ) : null}
                    </div>
                    <div className="spacer-inline field-ext v-top">
                      <label for="PhoneExt">Ext</label>
                      <input
                        className="form-control"
                        name="PhoneExt"
                        type="number"
                        maxLength={6}
                        value={answers?.Addresses?.PhoneExt}
                        onChange={(el) => {
                          let vl = el.target.value;
                          if (vl.length < 7) {
                            setAnswer("PhoneExt", el.target.value, true);
                          }
                        }}
                      />
                    </div>
                  </div>
                  {/*Fax*/}
                  <div className="field-wrapper">
                    <div className="field-box1">
                      <label for="Fax">Fax</label>
                      <input
                        className="form-control"
                        id="Fax"
                        name="Fax"
                        placeholder="Optional"
                        value={formatPhoneNumber(answers?.Addresses?.Fax)}
                        onChange={(el) =>
                          setAnswer("Fax", el.target.value, true)
                        }
                      />
                      {answers?.Addresses?.Fax?.length < 14 &&
                      frmSubmFlag &&
                      answers?.Addresses?.Fax.length > 0 ? (
                        <div className="alert alert-danger">
                          Invalid Fax Number
                        </div>
                      ) : null}
                    </div>
                    <div className="spacer-inline field-ext v-top">
                      <label for="FaxExt">Ext</label>
                      <input
                        className="form-control"
                        name="FaxExt"
                        type="number"
                        onChange={(el) => {
                          let vl = el.target.value;
                          if (vl.length < 7) {
                            setAnswer("FaxExt", el.target.value, true);
                          }
                        }}
                        value={answers?.Addresses?.FaxExt}
                      />
                    </div>
                  </div>
                  {/*External ID*/}
                  <div className="field-wrapper">
                    <label for="ExternalId">External ID</label>
                    <input
                      className="form-control"
                      name="ExternalId"
                      placeholder="Optional"
                      value={answers?.ExternalId}
                      onChange={(el) =>
                        setAnswer("ExternalId", el.target.value)
                      }
                    />
                  </div>
                  {/*Specialty*/}
                  <div className="field-wrapper title-divider">Specialty</div>
                  <div className="field-wrapper text-reg">
                    This section is optional but we highly recommend you select
                    these options to identify specific areas of focus in the
                    organization.{" "}
                    <b className="or-clr">
                      If you select a type, then you must select both
                      classification and specialization.
                    </b>
                  </div>
                  {/*Specialty Component*/}
                  <SpecialtyDropdown
                    SpecialFormFields={(el, val) => SpecialFormFields(el, val)}
                    codes={orgValues?.codes}
                    editObj={specialtiesObj}
                  />
                  {specialtiesFlag && frmSubmFlag ? (
                    <div className="alert alert-danger" id="SpecialtyId">
                      Specialization is required when you are selecting Type or
                      Classification.
                    </div>
                  ) : null}

                  {userRole !== "SES ADMINISTRATOR" ? null : (
                    <>
                      {/*Email Delivery*/}
                      <div className="field-wrapper title-divider">
                        Email Delivery
                      </div>
                      {/*Outbound XDR*/}
                      <div>
                        {CustCheckboxes.ApplicationAccessXDR &&
                        answers?.ApplicationAccessXDR ? (
                          <>
                            <div className="field-wrapper">
                              <label for="OutboundXDRSelected">
                                Inbound XDR:
                              </label>
                              <input
                                className="form-control spacer-margin2"
                                type="checkbox"
                                name="XDREnabled"
                                value={answers?.XDREnabled}
                                checked={answers?.XDREnabled}
                                onChange={(el) =>
                                  setAnswer("XDREnabled", el.target.checked)
                                }
                              />
                              <select
                                className="form-control w-lg6 spacer-inline"
                                name="OutboundXDRConfigName"
                                value={answers?.OutboundXDRConfigName}
                                onChange={(el) => {
                                  SetSharedObject("xdrAdded", false);
                                  GetXdrConfig(el.target.value);
                                }}
                                disabled={!answers?.XDREnabled}
                              >
                                <option value="">
                                  Add Or Select XDR Configuration
                                </option>
                                {XdrArr?.map((el) => (
                                  <option key={el.id} value={el.id}>
                                    {el.endpointName}
                                  </option>
                                ))}
                              </select>
                              <button
                                type="button"
                                className="btn btn-primary spacer-margin2"
                                onClick={(el) => handleXDR()}
                                data-toggle="modal"
                                disabled={!answers?.XDREnabled}
                              >
                                <i className="bi bi-gear"></i>
                              </button>
                            </div>
                          </>
                        ) : null}
                        <div className="field-wrapper">
                          {CustCheckboxes.ApplicationAccessXDR === true ? (
                            <label for="InboundXDR">Outbound XDR</label>
                          ) : null}
                          {CustCheckboxes.ApplicationAccessXDR === true &&
                          answers?.ApplicationAccessXDR ? (
                            <>
                              <section>
                                <input
                                  className="form-control spacer-margin5"
                                  type="checkbox"
                                  name="IsEpicOrganization"
                                  id="IsEpicOrganization"
                                  checked={answers?.IsEpicOrganization}
                                  value={answers?.IsEpicOrganization}
                                  onClick={(el) =>
                                    setAnswer(
                                      "IsEpicOrganization",
                                      el.target.checked
                                    )
                                  }
                                />
                                <span for="InboundXDR" className="label-sub">
                                  Create Direct Automatically
                                </span>
                                <a
                                  href="#CreateDirect"
                                  data-toggle="collapse"
                                  aria-expanded="false"
                                  aria-controls="CreateDirect"
                                >
                                  <i className="bi bi-plus-lg sm-icon-container"></i>
                                </a>
                                <div
                                  className="collapse text-reg sub-catg"
                                  id="CreateDirect"
                                >
                                  Emails are created in the organization
                                  according to the certificate used to
                                  authenticate the INBOUND connection.
                                </div>
                              </section>
                              <section>
                                {/*<input*/}
                                {/*  className="form-control spacer-margin5"*/}
                                {/*  type="checkbox"*/}
                                {/*  name="OutOfNetwork"*/}
                                {/*  id="OutOfNetwork"*/}
                                {/*  checked={answers?.OutOfNetwork}*/}
                                {/*  value={answers?.OutOfNetwork}*/}
                                {/*  onClick={(el) =>*/}
                                {/*    setAnswer("OutOfNetwork", el.target.checked)*/}
                                {/*  }*/}
                                {/*/>*/}
                                {/*<span for="OutNetwork" className="label-sub">*/}
                                {/*  Out of Network*/}
                                {/*</span>*/}
                              </section>
                            </>
                          ) : null}
                          {CustCheckboxes.ApplicationAccessXDR ? (
                            <section>
                              <input
                                className="form-control spacer-margin5"
                                type="checkbox"
                                name="XDRDoNOTGenerateXDM"
                                id="XDRDoNOTGenerateXDM"
                                checked={!answers?.XDRDoNOTGenerateXDM}
                                value={!answers?.XDRDoNOTGenerateXDM}
                                onClick={(el) =>
                                  setAnswer(
                                    "XDRDoNOTGenerateXDM",
                                    !el.target.checked
                                  )
                                }
                              />
                              <span for="xdmDelivery" className="label-sub">
                                {" "}
                                XDM Delivery{" "}
                              </span>
                              <a
                                href="#xdmDelivery"
                                data-toggle="collapse"
                                aria-expanded="false"
                                aria-controls="xdmDelivery"
                              >
                                {" "}
                                <i className="bi bi-plus-lg sm-icon-container"></i>{" "}
                              </a>
                              <div
                                className="collapse text-reg sub-catg"
                                id="xdmDelivery"
                              >
                                If checked, message delivered over XDR will be
                                packaged as Direct message with XDM attachment.
                                Please make sure your recipients can accept and
                                handle XDM.
                              </div>
                            </section>
                          ) : null}
                        </div>
                      </div>
                      <div className="field-wrapper">
                        <label for="KeepMDN">Keep MDN:</label>
                        <input
                          className="form-control spacer-margin2"
                          type="checkbox"
                          name="KeepMDN"
                          id="KeepMDN"
                          checked={answers?.KeepMDN}
                          value={answers?.KeepMDN}
                          onClick={(el) =>
                            setAnswer("KeepMDN", el.target.checked)
                          }
                        />
                      </div>
                      <div className="field-wrapper title-divider">
                        Permissions
                      </div>

                      <div className="field-wrapper">
                        {/*Two Factor Enable and Disable*/}
                        {permissions === true ? (
                          <div className="sub-catg ctr">
                            There are no permissions for this organization.
                          </div>
                        ) : null}

                        {CustCheckboxes.TwoFactorAuth ? (
                          <div>
                            <section>
                              <input
                                className="form-control spacer-margin5"
                                type="checkbox"
                                name="AllowTwoFactor"
                                id="AllowTwoFactor"
                                checked={answers?.TwoFactorAuth}
                                value={answers?.TwoFactorAuth}
                                onClick={(el) =>
                                  setAnswer("TwoFactorAuth", el.target.checked)
                                }
                              />
                              <label>Two Factor Authentication</label>
                              <span>
                                <a
                                  href="#twoFactorInfo-1"
                                  data-toggle="collapse"
                                  aria-expanded="false"
                                  aria-controls="TwoFactorInfo"
                                  aria-describedby="Two Factor Information"
                                >
                                  <i className="bi bi-info-circle"></i>
                                </a>
                              </span>
                            </section>
                            <section
                              className="collapse text-reg"
                              id="twoFactorInfo-1"
                            >
                              Two-factor authentication improves your digital
                              security by protecting your account with an
                              additional login step. It makes it harder for
                              unauthorized users to gain access to an account
                              without permission.{" "}
                              <b>
                                Selecting the checkbox at the organization level
                                will enable two-factor authentication settings
                                for all users within this organization.
                                Deselecting the checkbox will disable them.
                              </b>
                            </section>
                          </div>
                        ) : null}
                        {/*End Two Factor*/}

                        {/*XDR Access Enable and Disable*/}

                        {CustCheckboxes.ApplicationAccessXDR ? (
                          <div>
                            <section>
                              <input
                                className="form-control spacer-margin5"
                                type="checkbox"
                                name="ApplicationAccessXDR"
                                id="ApplicationAccessXDR"
                                checked={answers?.ApplicationAccessXDR}
                                value={answers?.ApplicationAccessXDR}
                                onClick={(el) =>
                                  setAnswer(
                                    "ApplicationAccessXDR",
                                    el.target.checked
                                  )
                                }
                              />
                              <label>XDR-Access</label>
                            </section>
                          </div>
                        ) : null}

                        <div>
                          {/*Notify Enable or Disable*/}
                          {CustCheckboxes.ApplicationAccessENS ? (
                            <div>
                              <section>
                                <input
                                  className="form-control spacer-margin5"
                                  type="checkbox"
                                  name="ApplicationAccessENS"
                                  id="ApplicationAccessENS"
                                  checked={answers?.ApplicationAccessENS}
                                  value={answers?.ApplicationAccessENS}
                                  onClick={(el) =>
                                    setAnswer(
                                      "ApplicationAccessENS",
                                      el.target.checked
                                    )
                                  }
                                />
                                <label>Notify</label>
                              </section>
                            </div>
                          ) : null}
                          {/*DirectRoute Enable or Disable*/}
                          {CustCheckboxes.EmailForwardingType &&
                          CustCheckboxes.EmailForwardingType === 1 ? (
                            <>
                              <div>
                                <section>
                                  <input
                                    className="form-control spacer-margin5"
                                    type="checkbox"
                                    name="DirectRoute"
                                    id="DirectRoute"
                                    checked={answers?.DirectRoute}
                                    value={answers?.DirectRoute}
                                    onClick={(el) =>
                                      setDirectRoute(el.target.checked)
                                    }
                                  />
                                  <label>DirectRoute</label>
                                </section>
                              </div>
                            </>
                          ) : null}
                          {CustCheckboxes.EmailForwardingType &&
                          CustCheckboxes.EmailForwardingType === 2 ? (
                            <div>
                              <section>
                                <input
                                  className="form-control spacer-margin5"
                                  type="checkbox"
                                  name="AdvancedDirectRoute"
                                  id="AdvancedDirectRoute"
                                  checked={answers?.EmailForwardingTypeBox}
                                  value={answers?.EmailForwardingTypeBox}
                                  onClick={(el) =>
                                    setAdvancedDirectRoute(el.target.checked)
                                  }
                                />
                                <label>Advanced DirectRoute</label>
                              </section>
                            </div>
                          ) : null}

                          {/*Share Directory Listing Enable or Disable*/}

                          {CustCheckboxes.ShareDirectoryListing ? (
                            <div>
                              <section>
                                <input
                                  className="form-control spacer-margin5"
                                  type="checkbox"
                                  name="ApplicationAccessXDR"
                                  id="ApplicationAccessXDR"
                                  checked={answers?.ShareDirectoryListing}
                                  value={answers?.ShareDirectoryListing}
                                  onClick={(el) =>
                                    setAnswer(
                                      "ShareDirectoryListing",
                                      el.target.checked
                                    )
                                  }
                                />
                                <label>Share Directory Listing</label>
                              </section>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {errCreateMsg ? (
                        <div className={`alert alert-${colorMsg}`}>{msg}</div>
                      ) : null}
                    </>
                  )}
                </div>
                {/*Alert Messages
                <div className="alert alert-success" role="alert">
                  Organization has been updated successfully.
                </div>
                <div className="alert alert-danger" role="alert">
                  We cannot save your settings at this time. If the problem
                  persists please contact your administrator.
                </div>*/}
                {/*Processing and success or error message here.*/}

                {processing ? <div className="loading-edit"></div> : null}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={updateOrg}
                >
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={(e) => {
                    $("#editOrgModal").modal("hide");
                    SetFrmSubmFlag(false);
                    SetPhoneValidation(false);
                    SetFaxValidation(false);
                    ClearFields();
                    SetErrCreateMsg(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditOrg;
